import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getHRRequestList, deleteHRRequest } from '@actions/HRRequest';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import * as HRRequestType from '@scripts/HRRequestType';
import * as HRRequestStatusCode from '@scripts/HRRequestStatusCode';
import * as StatusCode from '@scripts/StatusCode';
import HRRequestDetail from './HRRequestDetail';
import styles from '@styles/hrRequest.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader, faCircleXmark, faArrowDownToSquare} from "@fortawesome/pro-duotone-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    divCell: {
        '& > .MuiAccordionSummary-content': {
            display: 'table',
            width: '100%',
        }
    },
    firstCell: {
        width: '20%',
        textAlign: 'left',
        height: '35px',
        float: 'left',
        '& > .MuiIconButton-root': {
            padding: 'unset !important',
            marginLeft: '0px !important'
        }
    },
    secondCell: {
        width: '40%',
        textAlign: 'left',
        fontWeight: 'bold',
        float: 'left'
    },
    thirdCell: {
        textAlign: 'left',
        float: 'right',
        marginTop: '12px',
        marginRight: '10px'
    },
    fourthCell: {
        width: '100%',
        textAlign: 'left',
        display: 'table',
        fontSize: '14px'
    },
    iconCancel: {
        color: 'red'
    },
    noBorder: {
        borderBottom: '0px!important'
    },
    status: {
        fontWeight: 'bold'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: 'var(--color1)!important'
    },
    cancelButton: {
        color: '#e109098a !important',
        width: "25px",
        height: "25px",
        "--fa-primary-color": "rgb(231, 122, 122)",
        "--fa-secondary-color": "rgb(231, 122, 122)"
    },
    divListHRRequest: {
        width: '100%',
        textAlign: 'center'
    },
    typeIconContainer: {
        marginRight: "10px",
        alignSelf: "center"
    },
    typeIcon: {
        fontSize: "25px",
        color: 'var(--color1)'
    }
}));

function HRRequestListItems(props) {
    const [data, setData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const { filter, isReload } = props;
    const { isHomePage } = props;

    const triggerReload = () => {
        loadData();
    };

    useEffect(() => {
        resizeForm();
    }, [])

    useEffect(() => {
        loadPage();
    }, [filter, isReload]);

    const loadPage = () => {
        if (filter != null && filter.requestType !== undefined && filter.requestType !== null) {
            loadData();
        }
    }

    const resizeForm = () => {
        // props.resizeForm is a custom function that is passed from the parent component to resize the form
        if (props.resizeForm != undefined && props.resizeForm != null) {
            props.resizeForm();
            return;
        }

        if (!isHomePage) {
            setTimeout(function () {
                const height = window.innerHeight;
                const titleBar = document.querySelector('#appBarTitle')?.clientHeight ?? 0;
                const header = document.querySelector('div[data-id=headerHRRequest]')?.offsetHeight ?? 0;
                const element = document.querySelector('#divListHRRequest');
                const offSet = 114;

                const customHeight = height - header - titleBar - offSet;

                if (element !== null) {
                    element.style.height = `${customHeight}px`;
                    element.style.overflowX = 'hidden';
                }
            }, 100);
        }
    }

    const handleDeleteClick = (event, obj) => {
        // Prevent the card's onClick from opening the detail dialog
        event.stopPropagation();

        setSelectedRequest(obj);
        setOpenDeleteDialog(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedRequest?.hrRequest?.hrRequestId) {
            return;
        }

        setOpenDeleteDialog(false);
        setIsActive(true);
        const result = await deleteHRRequest(selectedRequest.hrRequest.hrRequestId);

        if (result != null && result.status === StatusCode.STATUS_OK) {
            setSelectedRequest(null);
            await loadData();
        }
        else {
            showMessageError(i18next.t('error:generic-error'));
        }

        setIsActive(false);
    };

    const loadData = async () => {
        return new Promise(async (resolve) => {
            setIsActive(true);
            let requestType = filter.requestType;
            let status = filter.status;

            // default
            if (requestType === undefined || requestType === null) {
                requestType = [HRRequestType.Type_DocumentDeposit];
            }

            if (status === undefined || status === null) {
                status = [HRRequestStatusCode.NewRequest, HRRequestStatusCode.Processing, HRRequestStatusCode.InfoRequired, HRRequestStatusCode.Waiting];
            }

            if (requestType.length === 0 || status.length === 0) {
                setData(null);
                setIsActive(false);
                return;
            }

            // topSelect = 0 => all
            let topSelect = 0;

            if (isHomePage) {
                // Recent history get only top 5 records
                topSelect = 5;
            }

            const result = await getHRRequestList(status, requestType, topSelect);

            if (result !== undefined) {
                if (result != null && result.status == StatusCode.STATUS_OK) {
                    const parsedResult = JSON.parse(result.result);

                    parsedResult.list.sort(
                        (a, b) => new Date(b.createDate) - new Date(a.createDate)
                    );

                    let dataToSet = parsedResult.list;

                    // If topSelect > 0, keep only the first X records
                    if (topSelect > 0) {
                        dataToSet = dataToSet.slice(0, topSelect);
                    }

                    setData(dataToSet);
                } else {
                    showMessageError(i18next.t('error:generic-error'));
                }
                resolve();
            }

            setIsActive(false);
        })
    }

    const classes = useStyles();
    const alertRef = useRef(null);

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div id="divListHRRequest" data-type={props.type} className={styles.konekCard + ' ' + classes.divListHRRequest}>
            {data && data.map((obj, index) =>
                <React.Fragment key={index}>
                    <ListItem key={index} button className="listItem" onClick={() => handleClick(obj)}>
                        <ListItemText disableTypography={true} primary={
                            <React.Fragment>
                                <div style={{ display: "flex" }}>
                                    <div className={classes.typeIconContainer}>
                                        {obj.hrRequestTypeId == '1' &&
                                            <FontAwesomeIcon icon={faArrowDownToSquare} className={classes.typeIcon} />
                                        }
                                    </div>
                                    <div style={{flex: "1"}}>
                                        <div className={classes.divCell}>
                                            <div>
                                                <div className={classes.secondCell}>
                                                    {obj.description}
                                                </div>
                                                <div className={classes.thirdCell}>
                                                    {obj.status == 'N' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusNewRequest}>{i18next.t('hrRequest:status.newRequest')}</span>
                                                    }
                                                    {obj.status == 'P' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusOpen}>{i18next.t('hrRequest:status.processing')}</span>
                                                    }
                                                    {obj.status == 'I' && !obj.isApproved &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusInfoRequired}>{i18next.t('hrRequest:status.infoRequired')}</span>
                                                    }
                                                    {obj.status == 'D' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusinfoReturned}>{i18next.t('hrRequest:status.infoReturned')}</span>
                                                    }
                                                    {obj.status == 'A' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusApproved}>{i18next.t('hrRequest:status.approved')}</span>
                                                    }
                                                    {obj.status == 'E' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusOpen}>{i18next.t('hrRequest:status.waiting')}</span>
                                                    }
                                                    {obj.status == 'C' &&
                                                        <span className={styles.statusIndicator + ' ' + styles.statusCancellationRequest}>{i18next.t('hrRequest:status.cancelled')}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.fourthCell}>{new Date(obj.createDate).toLocaleString()}</div>
                                    </div>
                                </div>
                            </React.Fragment>
                        } />
                        <ListItemSecondaryAction className={classes.divAction}>
                            <IconButton onClick={(event) => handleDeleteClick(event, obj)}>
                                <FontAwesomeIcon icon={faCircleXmark} className={classes.cancelButton} />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                </React.Fragment>
            )}

            {dataRow != null && <HRRequestDetail open={open} onClose={handleClose} data={dataRow} dataRequest={dataRow.HRRequest} onReload={triggerReload} />}
            {isActive && ( <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px" }} spin /> )}
            {!isActive && (!data || data.length === 0) && (<div style={{ textAlign: 'center', color: '#666' }} > {i18next.t('hrRequest:filter.noRequest')} </div>)}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} aria-labelledby="delete-dialog-title" >
                <DialogTitle id="delete-dialog-title">
                    {i18next.t('hrRequest:form.confirmDeleteTitle')}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        {i18next.t('hrRequest:form.confirmDeleteMessage')}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary" variant="contained" >
                        {i18next.t('hrRequest:buttons.cancel')}
                    </Button>

                    <Button onClick={handleConfirmDelete} color="primary" variant="contained" style={{ backgroundColor: '#b51200', color: '#fff' }} >
                        {i18next.t('hrRequest:buttons.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['hrRequest', 'error'], { wait: true })(HRRequestListItems);

HRRequestListItems.propTypes = {
    filter: PropTypes.object.isRequired
};